module.exports = __webpack_public_path__ + "media/images/emblems/La_Sonnaz-coat_of_arms-03e8db92561a02eae039d3aeb94a23b7.svg";